export default __webpack_public_path__ + "navigation-examples-embedded-navigation-960-ca17304192af247b9491e393dd01267b.png";